import { TicketAutomationRule } from './ticket-automation.model';

/**
 * Catálogo de automações do chamado — FONTE DA VERDADE das regras.
 *
 * Adicionar uma automação nova = mais um objeto neste array. Nenhum componente é tocado:
 * o serviço deriva os caminhos observados daqui e os hosts de dialog já estão montados nas
 * telas. Ver `docs/business/business-rules.md`.
 */

/** Servidor Nota Fiscal Eletrônica. */
const SISTEMA_NFE = '7ccaaa66-818d-4507-b995-de4c38e9d112';

const STATUS_TESTAR = 'cd9267b5-1272-4ec5-a528-c8032cc7eb84';
const STATUS_ATUALIZACAO_RELEASE = 'ab35c716-d03e-467a-8025-3c84f8a711a1';

/**
 * `type` é o campo "Tipo" do chamado (char), não `ticket_type_id` ("Tipo Chamada").
 * `L` = "Liberação pendente" — ver `constants.ticketcenter.ticketsTypes`. É esse valor que
 * bloqueia o fechamento do chamado sem aval do responsável (`isCloseBlocked` no painel).
 */
const TIPO_LIBERACAO_PENDENTE = 'L';

export const TICKET_AUTOMATION_RULES: TicketAutomationRule[] = [
  {
    id: 'nfe-testar-marca-liberacao-pendente',
    description:
      'Sistema NF-e movido para "Testar" → sugere marcar o Tipo como "Liberação pendente", ' +
      'para o chamado não ser fechado sem o aval do responsável.',
    when: { 'system.id': SISTEMA_NFE },
    changedTo: { 'status.id': STATUS_TESTAR },
    alreadyApplied: { type: TIPO_LIBERACAO_PENDENTE },
    apply: { type: TIPO_LIBERACAO_PENDENTE },
    prompt: {
      header: 'Sugestão de alteração',
      message:
        'O chamado do sistema "Servidor Nota Fiscal Eletrônica" foi movido para o status ' +
        '"Testar". Deseja alterar o Tipo para "Liberação pendente"?',
      batchMessage:
        '{count} chamado(s) do sistema "Servidor Nota Fiscal Eletrônica" foram movidos para ' +
        'o status "Testar". Deseja alterar o Tipo para "Liberação pendente"?',
      acceptLabel: 'Sim, alterar',
      rejectLabel: 'Não, manter',
    },
  },
  {
    id: 'nfe-atualizacao-release-limpa-tipo',
    description:
      'Sistema NF-e movido para "Atualizacao de Release" → sugere limpar o Tipo do chamado.',
    when: { 'system.id': SISTEMA_NFE },
    changedTo: { 'status.id': STATUS_ATUALIZACAO_RELEASE },
    // `null` casa com null/undefined/'' — se o Tipo já está vazio, não há o que sugerir.
    alreadyApplied: { type: null },
    apply: { type: null },
    prompt: {
      header: 'Sugestão de alteração',
      message:
        'O chamado do sistema "Servidor Nota Fiscal Eletrônica" foi movido para o status ' +
        '"Atualizacao de Release". Deseja limpar o Tipo do chamado (deixar vazio)?',
      batchMessage:
        '{count} chamado(s) do sistema "Servidor Nota Fiscal Eletrônica" foram movidos para ' +
        'o status "Atualizacao de Release". Deseja limpar o Tipo deles (deixar vazio)?',
      acceptLabel: 'Sim, limpar',
      rejectLabel: 'Não, manter',
    },
  },
];
